<template>
  <!-- Nav only — Intelligence Setup + Help are in AppNavigationDrawer.vue pinned footer -->
  <div class="navigation-drawer-nav-panel">
    <v-list nav dense class="navigation-drawer-nav-panel__nav app-navigation-drawer__gutter py-2 pt-1">
      <navigation-drawer-nav-item
        v-for="item in visiblePrimaryNav"
        :key="item.id"
        :item="item"
        :active="isPrimaryItemActive(item)"
        :to="primaryNavRouteLocation(item)"
        variant="primary"
        @click="onPrimaryNavClick(item)"
      />
    </v-list>

    <div class="app-navigation-drawer__section mt-2">
      <div class="app-navigation-drawer__section-label px-2 py-1 text-caption font-weight-medium">
        Directories
      </div>
      <v-list dense class="py-0">
        <navigation-drawer-nav-item
          v-for="item in directoriesNav"
          :key="item.id"
          :item="item"
          :active="isItemActive(item)"
          :to="navRouteLocation(item)"
          variant="section"
          @click="onNavItemClick(item)"
        />
      </v-list>
    </div>

    <div class="app-navigation-drawer__section mt-3">
      <div class="app-navigation-drawer__section-label px-2 py-1 text-caption font-weight-medium">
        My Items
      </div>
      <v-list dense class="py-0">
        <navigation-drawer-nav-item
          v-for="item in visibleMyItems"
          :key="item.id"
          :item="item"
          :active="isItemActive(item)"
          :to="navRouteLocation(item)"
          variant="section"
          @click="onNavItemClick(item)"
        />
      </v-list>
    </div>
  </div>
</template>

<script>
import {
  primaryNav,
  directoriesNav,
  myItemsNav,
  filterNavItems,
  getNavRouteLocation,
  isNavItemActive,
} from '@/config/appNavigation.js';
import NavigationDrawerNavItem from './NavigationDrawerNavItem.vue';

export default {
  name: 'NavigationDrawerNavPanel',

  components: {
    NavigationDrawerNavItem,
  },

  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
    savedSearchesDrawerOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      directoriesNav,
    };
  },

  computed: {
    visiblePrimaryNav() {
      return filterNavItems(primaryNav);
    },
    visibleMyItems() {
      return filterNavItems(myItemsNav, { isAdmin: this.isAdmin });
    },
  },

  methods: {
    primaryNavRouteLocation(item) {
      if (!item?.route) {
        return undefined;
      }
      return getNavRouteLocation(item);
    },
    navRouteLocation(item) {
      return getNavRouteLocation(item);
    },
    isPrimaryItemActive(item) {
      if (item?.action === 'openSavedSearchesDrawer') {
        return this.savedSearchesDrawerOpen;
      }
      if (this.savedSearchesDrawerOpen) {
        return false;
      }
      return isNavItemActive(item, this.$route);
    },
    isItemActive(item) {
      if (this.savedSearchesDrawerOpen) {
        return false;
      }
      return isNavItemActive(item, this.$route);
    },
    onPrimaryNavClick(item) {
      this.onNavItemClick(item);
    },
    onNavItemClick(item) {
      if (item?.action === 'openSavedSearchesDrawer') {
        this.$emit('toggle-saved-searches-drawer');
        return;
      }
      if (this.savedSearchesDrawerOpen) {
        this.$emit('close-saved-searches-drawer');
      }
    },
  },
};
</script>

<style scoped>
.navigation-drawer-nav-panel {
  min-height: 0;
  padding-bottom: 8px;
}

.app-navigation-drawer__gutter {
  padding-left: 8px;
  padding-right: 8px;
}

.app-navigation-drawer__section {
  margin-left: 8px;
  margin-right: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
}

.app-navigation-drawer__section-label {
  color: rgba(255, 255, 255, 0.55);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
